import type { AppDispatch, RootState } from './types'

type GlobalStore = {
	dispatch?: AppDispatch
	getState?: () => RootState
}

export const globalStore: GlobalStore = {}

export const setGlobalStore = (store?: GlobalStore | null): void => {
	globalStore.dispatch = store?.dispatch
	globalStore.getState = store?.getState
}

export const getGlobalStore = (): GlobalStore => globalStore
